const base = process.env.REACT_APP_BACKEND_URL ?? 'https://demoapi.doodooc.com';

export default {
    apiBaseUrl: `${base}`,
    imagesBaseUrl: `${base}/public`,
}
